import {createStore} from 'redux';
import reducers from './Reducers';
import {LOAD_USER_ERROR, LOADING_USER, loadUser, reducer, SESSION_TERMINATED, SILENT_RENEW_ERROR, USER_EXPIRED, USER_EXPIRING, USER_FOUND, USER_SIGNED_OUT} from "redux-oidc";
import userManager from './UserManager';
import {TABS_STRUCTURE} from '../misc/Shared';

const oidcReducer = reducer;

export const oidcReducers = {
	[USER_EXPIRED]: USER_EXPIRED,
	[SILENT_RENEW_ERROR]: SILENT_RENEW_ERROR,
	[SESSION_TERMINATED]: SESSION_TERMINATED,
	[USER_EXPIRING]: USER_EXPIRING,
	[USER_FOUND]: USER_FOUND,
	[LOADING_USER]: LOADING_USER,
	[USER_SIGNED_OUT]: USER_SIGNED_OUT,
	[LOAD_USER_ERROR]: LOAD_USER_ERROR
};

const reduxStore = createStore((state, action) => {
		// === reducers ===
		let reducer = false;

		// is reducer valid?
		if (action.type in reducers) {
			reducer = reducers[action.type];
		} else if (action.type in oidcReducers){
			reducer = oidcReducer;
		}

		// ignore redux/react "system" reducers
		if (!reducer && action.type.indexOf('@@') !== 0 && action.type.indexOf('redux-oidc') !== 0) {
			console.error('unknown reducer action:', action.type, action);
		}

		// DO IT!
		return reducer ? reducer(state, action) : state;
	}, {
		user: {},
		app: {
			admin: false,
			currentCobiId: undefined,
			currentFund: undefined,
			currentIssueKey: undefined,
			currentPageTitle: undefined,
			currentTab: undefined,
			currentYear: undefined,
			currentFiscalYear: undefined,
			currentEditorFiscalYear: undefined,
			draft: false,
			fiscalYears: undefined,
			version: {
				client: {},
				ws: ''
			},
			editing: {
				[TABS_STRUCTURE.OVERVIEW]: {
					original: undefined,
					editor: undefined,
					edited: false,
					active: false,
					comments: [],
				},
				[TABS_STRUCTURE.ISSUES]: {
					original: undefined,
					editor: undefined,
					edited: false,
					active: false,
					comments: [],
				},
				[TABS_STRUCTURE.PERFORMANCE]: {
					original: undefined,
					editor: undefined,
					edited: false,
					active: false,
					comments: [],
				},
				[TABS_STRUCTURE.BACKGROUND]: {
					original: undefined,
					editor: undefined,
					edited: false,
					active: false,
					comments: [],
				},
				[TABS_STRUCTURE.FINANCIALS]: {
					original: undefined,
					editor: undefined,
					edited: false,
					active: false,
					comments: [],
				},
				cobiIdActive: true,
			},
			issueText: false,
		},
		menu: {
			menuObj: {},
			menuMap: undefined
		},
		userAccount: {
			utahId: undefined,
			userId: undefined,
			firstName: undefined,
			lastName: undefined,
			fullName: undefined,
			email: undefined,
			roleName: undefined,
			active: undefined,
		},
		messages: [],
		historyStack: []
	}

	// for chrome redux plugin
	, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

loadUser(reduxStore, userManager);

export default reduxStore;
